import { ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, OnInit } from "@angular/core";
import { ViewEncapsulation } from "@angular/core";
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { User } from '@core/models/user/user';
import { AvatarComponent } from '@components/avatar/avatar.component';
import { SessionService } from '@core/state/session/session.service';
import { AccountRole } from "@core/models/account/account-role";
import { takeUntil } from "rxjs/operators";
import { Company } from "@core/models/common/company";
import { Subject } from "rxjs";
import { AuthService } from "@core/state/auth/auth.service";
import { CompanySelectorComponent } from "../company-selector/company-selector.component";
import { PopComponentModule } from "@components/pop/pop.component.module";
import { TranslateModule } from "@ngx-translate/core";
import { ElementsModule } from "@shared/elements/elements.module";
import { POP_DIRECTION } from "@components/pop/pop-direction";
import { POP_ALIGNMENT } from "@components/pop/pop-alignment";
import { PipesModule } from "@shared/pipes/pipes.module";
import { WindowRef } from '@vendor/window/window.component';
import { environment } from "@environments/environment";
@Component({
    selector: 'pay-profile-menu',
    templateUrl: './profile-menu.component.html',
    styleUrls: ['./profile-menu.component.scss'],
    imports: [
        CommonModule,
        ElementsModule,
        AvatarComponent,
        PopComponentModule,
        CompanySelectorComponent,
        TranslateModule,
        PipesModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        'class': 'c-profile-menu'
    }
})
export class ProfileMenuComponent implements OnInit, OnDestroy {

    public readonly DIRECTION: POP_DIRECTION = POP_DIRECTION.BOTTOM;
    public readonly ALIGNMENT: POP_ALIGNMENT = POP_ALIGNMENT.RIGHT;
    public readonly feedbackUrl: string = environment.assets.feedbackUrl;
    public readonly helpUrl: string = environment.assets.helpUrl;

    public user: User;
    public company: Company;
    public hasMultipleCompanies: boolean;
    public showDropdown: boolean = false;
    public showCompanyList: boolean = false;
    public isAdmin: boolean;
    public isManager: boolean;

    private destroyed$: Subject<void> = new Subject();
    private nativeWindow: Window;

    constructor(private cdr: ChangeDetectorRef,
        private windowRef: WindowRef,
                private sessionService: SessionService,
                private authService: AuthService ) {

        this.nativeWindow = windowRef.nativeWindow;
    }

    ngOnInit(): void {
        this.sessionService.getCompany()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((company: Company) => {
                this.company = company;
                this.isAdmin = company?.role === AccountRole.ADMIN;
                this.isManager = company?.role === AccountRole.MANAGER;
                this.cdr.markForCheck();
            });

        this.sessionService.getUser()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((user: User) => {
                this.user = user;
                this.hasMultipleCompanies = (user?.companies || []).filter((company: Company) => company.id !== this.company?.id).length > 0;
                this.cdr.markForCheck();
            });
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
        this.cdr.markForCheck();
    }

    showCompanies() {

    }

    toggleCompanyList() {
        this.showCompanyList = !this.showCompanyList;
        this.cdr.markForCheck();
    }

    logout() {
        this.authService.logout();
    }

    goToFeedback() {
        this.nativeWindow.open(this.feedbackUrl, '_blank');
    }

    goToHelp() {
        this.nativeWindow.open(this.helpUrl, '_blank');
    }
}
